import {Atom, withSystem} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {TList, TElement} from '@packages/systems/wfdl-ast';

// The Symbol atom is not used for rendering anymore and only still exists
// temporarily to not break `getAtom` calls.
const Symbol = Atom.createRender(() => null);

const config = createIntegratedAtom({
  showEmpty: false,
  render: Symbol,
  fields: {
    children: TList(withSystem({private: true}, TElement)),
  },
});

export default config;
